import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The catalog-style image-upload tile: an `app-item-image` preview with a
 * hover opacity layer, cloud-upload icon, invisible full-size file input and
 * an optional remove cross. This exact block (markup + scss) was duplicated
 * across store-offer, child-offer, store-category and promotion-form — the
 * component owns it once, centrally.
 *
 * The parent keeps the upload/remove logic: `(fileSelected)` re-emits the raw
 * `change` event (handlers keep reading `$event.target.files`), `(removeClick)`
 * fires when the cross is clicked.
 */
@Component({
  selector: 'app-item-image-upload',
  templateUrl: './item-image-upload.component.html',
  styleUrls: ['./item-image-upload.component.scss'],
})
export class ItemImageUploadComponent {
  /** Resolved image URL to preview; empty/null renders the placeholder tile. */
  @Input() imageUrl: string | null = '';
  /** Title attribute on the file input (already-translated string). */
  @Input() uploadTitle = '';
  /** Hide the file input entirely (role-gated screens). */
  @Input() canUpload = true;
  /** Show the remove cross. */
  @Input() canRemove = false;
  /** Read-only presentation: no hover effects, no upload affordance. */
  @Input() readOnly = false;
  /** Id kept on the file input for e2e selectors (legacy id). */
  @Input() inputId = 'uploadImage';
  /** app-item-image size of the preview tile ('large' | 'extra-large'). */
  @Input() imageSize = 'extra-large';
  @Input() accept = 'image/*';
  /** Translate key for the placeholder tile caption. */
  @Input() uploadText = 'admin.store.catalog.offer.uploadImage';

  /** Raw change event of the file input. */
  @Output() fileSelected = new EventEmitter<Event>();
  @Output() removeClick = new EventEmitter<void>();
}
